import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  line: {
    position: 'absolute',
    top: -2,
    left: -1.5,
    right: -1.5,
    bottom: 0,
    borderWidth: 1,
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Textfield/src/components/line/styles.js